import { CONSENT_NAME_PREFIX } from '../store/applicationform/applicationFormSelectors';
import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export type ConsentType = 'TERMS_LOANS' | 'TERMS_PPI' | 'MARKETING_ELECTRONIC' | 'TERMS_CREDIT_STATUS' | 'MONTIO';
export type ConsentDisplayType = 'CHECKBOX' | 'CHECKBOX_RADIO' | 'INFORMATION' | 'CHECKBOX_DEFAULT_CHECKED';

export type ConsentDetailResponse = {
    /**
     * The unique id of the consent
     */
    id: string;

    /**
     * The consent display type
     */
    displayType: ConsentDisplayType;

    /**
     * The label of the consent
     */
    label: string;

    /**
     * View id
     */
    viewId: string;
    /**
     * Additional information about the consent given in HTML
     */
    information?: string;

    /**
     * If the consent is required
     */
    required: boolean;
};

/**
 * Internal representation of the consent
 */
export type Consent = {
    /**
     * The name should be in the format
     * CONSENT:{consentType}:{id}
     */
    name: string;
    /**
     * The consent display type
     */
    displayType: ConsentDisplayType;

    /**
     * The label of the consent
     */
    label: string;

    /**
     * id
     */
    id: string;
    /**
     * View id
     */
    viewId: string;

    /**
     * Additional information about the consent given in HTML
     */
    information?: string;

    /**
     * If the consent is required
     */
    required: boolean;
};

export const getConsentsService = async (
    apiProxyPath: string,
    consentType: ConsentType,
    apiKey: string,
    authenticationData?: AuthenticationData,
): Promise<Consent[]> => {
    const response = await apiClient<{ consentDetails?: ConsentDetailResponse[] }>(
        `${apiProxyPath}/application/consent/${consentType}`,
        {
            method: 'GET',
            apiKey,
            authenticationData,
            sentryTag: 'get_consents',
            sentryExtra: { consentType },
        },
    );
    return (response?.consentDetails ?? []).map(
        (consent) => ({ ...consent, name: `${CONSENT_NAME_PREFIX}:${consentType}:${consent.id}` }) as Consent,
    );
};
